import "./Item.css";
import { ItemDetailsData } from "../../../../Utils/DefinitionsInterfaces";
import usePricing from "../../../../Utils/hooks/usePricing";

interface ItemPropsInterface {
  stateCheckoutItem: ItemDetailsData;
  isDefaultItem: boolean;
  cbRemoveProduct: (itemId: number) => void;
}

const Item = (props: ItemPropsInterface) => {
  const { getDisplayPrice, formatPrice } = usePricing("cod");

  const displayPrice = getDisplayPrice(props.stateCheckoutItem.id);

  const RoundComponent = () => {
    return (
      <div
        style={{
          height: "10px",
          width: "10px",
          backgroundColor: "rgba(154, 200, 254, 0.3)",
          border: "2px",
          borderColor: "rgba(35, 81, 136, 1)",
          borderRadius: 100,
          marginLeft: "10px",
          marginRight: "10px",
          marginTop: "10px",
        }}
      ></div>
    );
  };

  // Function to parse description and create line items
  const parseDescription = (description: string) => {
    // Debug: Log the description to see what we're working with
    console.log("Description received:", description);

    // Split by actual line breaks (\n) and filter out empty strings
    const lines = description.split("\n").filter((line) => line.trim() !== "");

    console.log("Parsed lines:", lines);

    if (lines.length === 0) return null;

    // First line is the header
    const headerLine = lines[0].trim();

    // Rest are sub-line items
    const subLines = lines.slice(1);

    return (
      <div>
        {/* Header line */}
        <div className="item-details-breakdown item-details-header">
          <RoundComponent />
          <div className="item-details-text item-details-header-text">
            {headerLine}
          </div>
        </div>

        {/* Sub-line items */}
        {subLines
          .map((line, index) => {
            let cleanLine = line.trim();

            // Handle bullet points that start with "- "
            if (cleanLine.startsWith("- ")) {
              cleanLine = cleanLine.substring(2); // Remove the "- " prefix
            }

            // Skip lines that are just whitespace or empty
            if (cleanLine === "") {
              return null;
            }

            return (
              <div
                key={index + 1}
                className="item-details-breakdown item-details-sub"
              >
                <RoundComponent />
                <div className="item-details-text">{cleanLine}</div>
              </div>
            );
          })
          .filter(Boolean)}
      </div>
    );
  };

  return (
    <div className="item">
      <div className="wrap">
        <div className="item-title">{props.stateCheckoutItem.name}</div>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <div
            style={{
              width: "60%",
              height: "2px",
              backgroundColor: "rgba(217, 217, 217, 1)",
              alignSelf: "center",
              marginRight: "10px",
            }}
          ></div>
          <div>
            <span
              style={{ textDecoration: "line-through", marginRight: "10px" }}
              className="text-wrapper-3"
            >
              {"₹" + props.stateCheckoutItem.base_price}
            </span>
            <span className="text-wrapper-3">{formatPrice(displayPrice)}</span>
          </div>
        </div>
      </div>

      <div className="item-description">
        <br />
        {props.stateCheckoutItem.description ? (
          parseDescription(props.stateCheckoutItem.description)
        ) : (
          <div className="item-details-breakdown">
            <RoundComponent />
            <div className="item-details-text">No description available</div>
          </div>
        )}
        <br />
      </div>
    </div>
  );
};

export default Item;
